export function normalizeTimeValue(value) {
  const normalized = String(value || "").trim();
  if (!normalized) return "";

  const twentyFourHourMatch = normalized.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (twentyFourHourMatch) {
    const hours = Number(twentyFourHourMatch[1]);
    const minutes = Number(twentyFourHourMatch[2]);
    if (!Number.isInteger(hours) || hours < 0 || hours > 23) return "";
    if (!Number.isInteger(minutes) || minutes < 0 || minutes > 59) return "";
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }

  const twelveHourMatch = normalized.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*([AaPp])[.]?[Mm][.]?$/);
  if (!twelveHourMatch) return "";

  const hour12 = Number(twelveHourMatch[1]);
  const minutes = Number(twelveHourMatch[2]);
  const period = String(twelveHourMatch[3] || "").toUpperCase() === "P" ? "PM" : "AM";
  if (!Number.isInteger(hour12) || hour12 < 1 || hour12 > 12) return "";
  if (!Number.isInteger(minutes) || minutes < 0 || minutes > 59) return "";

  let hours24 = hour12 % 12;
  if (period === "PM") hours24 += 12;
  return `${String(hours24).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export function get12HourTimeParts(value) {
  const normalized = normalizeTimeValue(value);
  if (!normalized) return { hour: "", minute: "", period: "" };

  const [hoursText, minute] = normalized.split(":");
  const hours = Number(hoursText);
  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 || 12;
  return {
    hour: String(hour12).padStart(2, "0"),
    minute,
    period,
  };
}

export function formatTime12Hour(value) {
  const { hour, minute, period } = get12HourTimeParts(value);
  if (!hour || !minute || !period) return "";
  return `${hour}:${minute} ${period}`;
}
